import React, { useLayoutEffect } from 'react';

import PropTypes from 'prop-types';

import Immutable from 'immutable';

import { connect } from 'react-redux';

import { TICKET_CORPORATE_CREDIT_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Loader from '../../../common/Loader';

import Content from '../../../layout/Content';

import NoDataResource from '../../../common/resource/NoDataResource';

import AddCreditLineForm from '../../human-resources/agency/AddCreditLineForm';

import {
  clearTicketCorporateCredit,
  getTicketCorporateCredit,
  patchTicketCorporateCreditCreditLine,
} from '../../../../actions/corporate/TicketCorporateCredit';

export const AddCreditLineTicketCorporateCredit = ({
  match: {
    params: { id: ticketCorporateCreditId },
  },
  dispatchGetTicketCorporateCredit,
  breadcrumbs,
  ticketCorporateCredit,
  loading,
  dispatchPatchTicketCorporateCreditCreditLine,
  dispatchClearTicketCorporateCredit,
}) => {
  useLayoutEffect(() => {
    dispatchGetTicketCorporateCredit({ ticketCorporateCreditId });

    return () => dispatchClearTicketCorporateCredit();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPatchTicketCorporateCreditCreditLine({
      ticketCorporateCreditId,
      amount: formValues.amount,
    });

  const generateInitialValues = (ticketCorporateCreditJson) => ({
    name: ticketCorporateCreditJson.name,

    initialBalance:
      ticketCorporateCreditJson.agency &&
      ticketCorporateCreditJson.agency.initialBalance,

    actualBalance:
      ticketCorporateCreditJson.agency &&
      ticketCorporateCreditJson.agency.actualBalance,
  });

  let content = null;

  if (loading) {
    content = <Loader />;
  } else if (ticketCorporateCredit.isEmpty()) {
    content = <NoDataResource returnPage={TICKET_CORPORATE_CREDIT_PATH} />;
  } else {
    content = (
      <AddCreditLineForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(ticketCorporateCredit.toJS())}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Incrementar Saldo"
      subtitle="Incrementar saldo de crédito corporativo de tickets"
      content={content}
    />
  );
};

const mapStateToProps = (
  { CorporateUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Créditos Corporativos de Ticket',
      href: TICKET_CORPORATE_CREDIT_PATH,
    },
    {
      text: 'Ver',
      href: `${TICKET_CORPORATE_CREDIT_PATH}/${id}`,
    },
    {
      text: 'Incrementar Saldo',
      href: '',
    },
  ],

  ticketCorporateCredit: CorporateUnit.TicketCorporateCredit.getIn([
    'current',
    'content',
  ]),

  loading: !CorporateUnit.TicketCorporateCredit.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetTicketCorporateCredit: getTicketCorporateCredit,

  dispatchClearTicketCorporateCredit: clearTicketCorporateCredit,

  dispatchPatchTicketCorporateCreditCreditLine:
    patchTicketCorporateCreditCreditLine,
};

AddCreditLineTicketCorporateCredit.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchPatchTicketCorporateCreditCreditLine: PropTypes.func.isRequired,

  dispatchGetTicketCorporateCredit: PropTypes.func.isRequired,

  dispatchClearTicketCorporateCredit: PropTypes.func.isRequired,

  match: matchPropTypes.isRequired,

  ticketCorporateCredit: PropTypes.instanceOf(Immutable.Map).isRequired,

  loading: PropTypes.bool,
};

AddCreditLineTicketCorporateCredit.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCreditLineTicketCorporateCredit);
